import { tagsInputAnatomy } from "@chakra-ui/react/anatomy";
import { defineSlotRecipe } from "@chakra-ui/react/styled-system";

export default defineSlotRecipe({
  slots: tagsInputAnatomy.keys(),

  base: {
    control: {
      paddingEnd: "10",
    },
    item: {
      minWidth: "0",
    },
    itemPreview: {
      border: "none",
      minWidth: "0",
      maxWidth: "100%",
      bg: "colorPalette.muted",
      color: "colorPalette.fg",
    },
    itemText: {
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      maxWidth: "12rem",
    },
  },

  variants: {
    variant: {
      outline: {},
      subtle: {
        control: {
          bg: "bg.muted",
        },
      },
    },
  },

  defaultVariants: {
    variant: "outline",
  },
});
